import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { SBBSvg } from "./SBBSvg"

const Header = ({ siteTitle }) => (
  <nav className="navbar navbar-expand-lg navbar-light bg-light">
    <button
      className="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span className="navbar-toggler-icon"></span>
    </button>

    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav mr-auto">
        <li className="nav-item active">
          <Link to="/" className="nav-link" >
            Home
          </Link>
        </li>
        <li className="nav-item">
        <Link to="/dev-docs" className="nav-link" >
            Docs 
          </Link>
        </li>
        <li className="nav-item dropdown">
        <Link to="/trends" className="nav-link" >
            Trends
          </Link>
        </li>
      </ul>
    </div>
    <SBBSvg/>
  </nav>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
